import ContentDescriptionLarge from '@blocks/content/descriptionLarge/DescriptionLarge.svelte';
import ContentInfo from '@blocks/content/info/Info.svelte';
import ContentColumn from '@blocks/content/columns/Column.svelte';
import ContentQuoteList from '@blocks/content/quoteList/QuoteList.svelte';

export const ID_TO_BLOCK = new Map([
	['content_description_large', ContentDescriptionLarge],
	['content_info', ContentInfo],
	['content_column', ContentColumn],
	['content_quote_list', ContentQuoteList]
]);
